
import { useEffect } from 'react'
import Select from 'react-select'
import { WTPFilterBatteryNoDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WTPFilterBatteryNoDDL = (props) => {
    const { FilterBatteryNo, setFilterBatteryNo, rowData, Flag,IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            Flag: Flag,
        }
        dispatch(WTPFilterBatteryNoDDLAPI({ data }))
    }, [IsPost])

    const { WTPFilterBatteryNoData } = useSelector(state => state.WTPFilterBatteryNoDDL)

    useEffect(() => {
        handleWTPFilterBatteryNoDDL()
    }, [WTPFilterBatteryNoData])

    const handleWTPFilterBatteryNoDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPFilterBatteryNoData && WTPFilterBatteryNoData.table && WTPFilterBatteryNoData.table.length > 0) {
            let list = WTPFilterBatteryNoData.table.map((item, index) => ({
                value: item.m_wtP_FilterBatteryNoID,
                label: item.filterBatteryNo,
            }))
            setFilterBatteryNo({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_wtP_FilterBatteryNoID : 0,
                Label: Flag === 'Update' ? rowData.filterBatteryNo : "Select...",
            })
        }
        else {
            setFilterBatteryNo({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Filter Battery No</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={120}
                value={{ value: FilterBatteryNo.ID, label: FilterBatteryNo.Label }}
                onChange={(e) => {
                    e ?
                        setFilterBatteryNo({ ...FilterBatteryNo, ID: e.value, Label: e.label })
                        :
                        setFilterBatteryNo({ ...FilterBatteryNo, ID: 0, Label: "Select..." })

                }}
                options={FilterBatteryNo.DDL}
            />
        </div>
    )
}